import React from 'react'
import { containerIds } from 'modules/ui'
import Employee from 'components/business/Employee'
import Pager from 'components/business/shared/Pager'

export default class EmployeeList extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
  }

  onClick(e) {
    e.preventDefault()
    const { actions } = this.props
    actions.setUIState(containerIds.BUSINESS_EMPLOYEE, {
      showPendingList: true,
    })
    const location = {
      search: '?page=1',
    }
    this.props.history.push(location)
  }

  render() {
    const {
      match,
      company,
      actions,
      ui,
      data,
      updateCompanyEmployee,
      deleteCompanyEmployee,
    } = this.props
    const { pageInfo } = data.company.employees

    return (
      <div>
        <ul style={{ overflow: 'auto' }}>
          <a href="" onClick={this.onClick}>
            <li className="business-employee__list-tab">
              {i18n.t('page.employee.l_00006')}
            </li>
          </a>
          <li className="business-employee__list-tab-current">
            {i18n.t('page.employee.l_00007')}
          </li>
        </ul>
        <div className="business-employee__table">
          <table className="business-reservation__table">
            <thead>
              <tr className="business-reservation__line">
                <th className="business-employee__name-heading">
                  {i18n.t('page.employee.heading.name')}
                </th>
                <th className="business-employee__authority-heading">
                  {i18n.t('page.employee.heading.authority')}
                </th>
                <th className="business-employee__mail-heading">
                  {i18n.t('page.employee.heading.email')}
                </th>
                <th className="business-employee__confirm-heading">
                  {i18n.t('page.employee.heading.confirm')}
                </th>
              </tr>
            </thead>
            <tbody>
              {company.employees.results.map(employee => (
                <Employee
                  key={employee.id}
                  employee={employee}
                  updateCompanyEmployee={updateCompanyEmployee}
                  deleteCompanyEmployee={deleteCompanyEmployee}
                  actions={actions}
                  ui={ui}
                />
              ))}
            </tbody>
          </table>
        </div>
        {pageInfo.totalPages > 1 && (
          <Pager
            variables={data.variables}
            pathName={match.url}
            pageInfo={pageInfo}
            windowSize={1}
          />
        )}
      </div>
    )
  }
}
